'use strict';

module.exports = require('../5/CheckObjectCoercible');



//////////////////
// WEBPACK FOOTER
// ./~/array.prototype.find/~/es-abstract/2019/RequireObjectCoercible.js
// module id = 127
// module chunks = 3